import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PermissoesService {

  private adminCompany: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private administrador: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private manager: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private activeMovementes: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private activePublications: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private acessoModulosSubject: BehaviorSubject<[]> = new BehaviorSubject([]);
  private configAcessSap: BehaviorSubject<{}> = new BehaviorSubject({});
  private accessModulesCompany: BehaviorSubject<any[]> = new BehaviorSubject([]);
  private accessPermissionsDept: BehaviorSubject<any[]> = new BehaviorSubject([]);
  private partnerListAccess: BehaviorSubject<any> = new BehaviorSubject({});
  private activeIntegrationsSub: BehaviorSubject<{sapB1: boolean, movimentos: boolean, clicksign: boolean, docusign: boolean}> = new BehaviorSubject({sapB1: false, movimentos: false, clicksign: false, docusign: false});

  private userModule: BehaviorSubject<{userGed: boolean,
                                       userAdmin: boolean,
                                       userContract: boolean,
                                       userTask: boolean
                                      }> = new BehaviorSubject({userGed: false,
                                                                userAdmin: false,
                                                                userContract: false,
                                                                userTask: false
                                                              })

  constructor() { }

  //#region === FUNCOES EMPRESA ADMINISTRADORA ===

  doSetAdminCompany(razaoSocial: string) {
    const harpa: boolean = (razaoSocial.toUpperCase() == 'HARPA BUSINESS SOFTWARE') ? true : false;

    this.adminCompany.next(harpa)
  }

  doGetAdminCompany(): boolean {
    return this.adminCompany.value;
  }

  //#endregion

  //#region === FUNCOES DA CONFIGURACAO DA EMPRESA COM SAP ===

  doSetConfigSapCompany(configSap: any) {
    this.configAcessSap.next(configSap);
  }

  doGetConfigSapCompany(): Observable<any> {
    return this.configAcessSap.asObservable();
  }

  doSetActiveIntegrationSub(input: {sapB1: boolean, movimentos: boolean, clicksign: boolean, docusign: boolean}) {
    this.activeIntegrationsSub.next(input);
  }

  doGetActiveIntegrationObs(): Observable<any> {
    return this.activeIntegrationsSub.asObservable();
  }

  //#endregion

  //#region === FUNÇÕES DA CONFIGURAÇÃO DE VISUALIZAÇÃO DE LISTAS SAP E HARPA ===

  doSetPartnerListAccess(partnerListParams: any) {
    this.partnerListAccess.next(partnerListParams);
  }

  doGetPartnerListAccess(): Observable<any> {
    return this.partnerListAccess.asObservable();
  }

  //#endregion

  //#region === FUNCOES DA CONFIGURACAO DA EMPRESA DE MOVIMENTOS AUTOMATICOS ===

  doSetCompanyActiveMovements(active: boolean) {
    this.activeMovementes.next(active);
  }

  doGetCompanyActiveMovements(): Observable<boolean> {
    return this.activeMovementes.asObservable();
  }

  doSetCompanyActivePublications(active: boolean) {
    this.activePublications.next(active);
  }

  doGetCompanyActivePublications(): Observable<boolean> {
    return this.activePublications.asObservable();
  }

  //#endregion

  //#region === FUNCOES DE MODULOES DA EMPRESA ===

  doSetAccessModulesCompany(modulesList: any[]) {
    this.accessModulesCompany.next(modulesList);
  }

  doGetAccessModulesCompany(): Observable<any[]> {
    return this.accessModulesCompany.asObservable();
  }

  doGetAccessModulesCompanyData(): any[] {
    return this.accessModulesCompany.value;
  }

  doCheckModuleCompany(moduleCode: string): boolean {
    if (!this.doGetAccessModulesCompanyData()) {
      return false;
    }

    const filteredList: any[] = this.doGetAccessModulesCompanyData().filter(f => (
      ( (f.codigo) && (f.codigo.toUpperCase() == moduleCode.toUpperCase()) )
    ))

    return (filteredList.length > 0)
  }

  //#endregion

  //#region === FUNCOES DAS PERMISSOES DO DEPARTAMENTO ===

  doSetAccessPermissionsDept(permissionsList: any[]) {
    this.accessPermissionsDept.next(permissionsList);
  }

  doGetAccessPermissionsDept(): any[] {
    return this.accessPermissionsDept.value;
  }

  doGetAccessPermissionsDeptObs(): Observable<any[]> {
    return this.accessPermissionsDept.asObservable();
  }

  doCheckPermissionsDept(deptId: string, moduleCode: string, permissionName: string): boolean {
    const filteredList: any[] = this.doGetAccessPermissionsDept().filter(f =>
      (
        f.dept_id == deptId &&
        ( (f.module_codigo) && (f.module_codigo.toUpperCase() == moduleCode.toUpperCase()) ) &&
        ( (f.permDept_titulo) && (f.permDept_titulo.toUpperCase() == permissionName.toUpperCase()) )
      ))

    return (filteredList.length > 0)
  }

  //#endregion

  //#region === FUNCOES DEPARTAMENTO ADMINISTRADOR ===

  getAdministrador() {
    return this.administrador
  }

  setAdministrador(_administrador: boolean) {
    this.administrador.next(_administrador)
  }

  //#endregion

  //#region === FUNCOES DEPARTAMENTO ADMINISTRADOR ===

  getManager() {
    return this.manager
  }

  setManager(_manager: boolean) {
    this.manager.next(_manager)
  }

   //#endregion

  doSetUserAccessModule(modulesList: string[]) {
    const userAccess: any = {};

    if ( (modulesList) && (modulesList.length) ) {
      userAccess['userAdmin'] = (modulesList.filter(s => ( (s) && (s.toLowerCase().includes(`ged`))) ).length > 0)
      userAccess['userGed'] = (modulesList.filter(s => ( (s) && (s.toLowerCase().includes(`ged`)))).length > 0)
      userAccess['userContract'] = (modulesList.filter(s => ( (s) && (s.toLowerCase().includes(`contrato`)))).length > 0)
      userAccess['userTask'] = (modulesList.filter(s =>( (s) && (s.toLowerCase().toLowerCase().includes(`tarefa`)))).length > 0)
      userAccess['userProcess'] = (modulesList.filter(s =>( (s) && (s.toLowerCase().toLowerCase().includes(`juridico`)))).length > 0)
      userAccess['userTimesheet'] = (modulesList.filter(s =>( (s) && (s.toLowerCase().toLowerCase().includes(`timesheet`)))).length > 0)
      userAccess['userExpense'] = (modulesList.filter(s =>( (s) && (s.toLowerCase().toLowerCase().includes(`expense`)))).length > 0)
      userAccess['userLegal'] = (modulesList.filter(s =>( (s) && (s.toLowerCase().toLowerCase().includes(`juridico`)))).length > 0)
      userAccess['userCase'] = (modulesList.filter(s =>( (s) && (s.toLowerCase().toLowerCase().includes(`case`)))).length > 0)
    }

    this.userModule.next(userAccess);
  }

  doGetUserModule(): any {
    return this.userModule.value;
  }

  getAcessoModuloObservable() {
    return this.acessoModulosSubject
  }

  getAcessoModulo() {
    return this.acessoModulosSubject.value
  }

  setAcessoModulo(_acessoModulo: []) {
    this.doSetUserAccessModule(_acessoModulo);

    this.acessoModulosSubject.next(_acessoModulo)
  }

}
